import superiorDireito from "../../assets/superiorDireito.png";
import inferiorDireito from "../../assets/inferiorDireito.png";
import centroEsquerdo from "../../assets/centroEsquerdo.png";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import style from "./Termos.module.css";
import { useState, useEffect } from "react";
import Logo from "../../assets/logoItera.png";
import Alerta from "../../components/alerta/Alerta";
import { z } from "zod";
import UsuarioApi from "../../services/UsuarioApi";
import { useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import DocTermo from "../../assets/Termos_Itera360.pdf";
import { FaFileDownload } from "react-icons/fa";

export default function Termos() {

    return (
        <div className={style.conteudo}>
            <div className={style.conteudo_esquerda}>
                <img
                    src={centroEsquerdo}
                    alt="centroEsquerdo"
                    className={style.centro_esquerdo}
                />
            </div>

            <div className={style.conteudo_total}>
                <img src={Logo} alt="logo" className={style.imagem_logo} />
                <div className={style.termos_texto}>
                    <h1>Termos de Uso e Condições Gerais – Itera360</h1>
                    <p><strong>Última atualização:</strong> 24/04/2025</p>
                    <p>Seja bem-vindo(a) à Itera360!</p>
                    <p>
                        Ao se cadastrar e utilizar nossa plataforma, você declara que leu, compreendeu e concorda com os termos abaixo,
                        que regulam o uso dos serviços educacionais oferecidos pela Itera360.
                    </p>

                    <h2>1. Objeto</h2>
                    <p>
                        A Itera360 oferece cursos, trilhas formativas, suporte técnico e conteúdos didáticos voltados à capacitação
                        profissional na área de Tecnologia da Informação, por meio de uma plataforma online, conforme a grade curricular definida.
                    </p>

                    <h2>2. Cadastro e Acesso</h2>
                    <p>O usuário deve fornecer informações corretas, completas e atualizadas no momento do cadastro.</p>
                    <p>O acesso à plataforma é pessoal e intransferível. É proibido compartilhar login e senha com terceiros.</p>
                    <p>O usuário é responsável por manter seus dados de acesso seguros e deve comunicar imediatamente qualquer uso não autorizado de sua conta.</p>

                    <h2>3. Obrigações do Usuário</h2>
                    <ul>
                        <li>Usar os conteúdos exclusivamente para fins pessoais e educacionais.</li>
                        <li>Respeitar colegas, instrutores e a equipe Itera360, mantendo uma conduta ética.</li>
                        <li>Cumprir prazos de atividades e avaliações, quando aplicável.</li>
                        <li>Possuir os equipamentos mínimos exigidos, como computador, fones USB e acesso à internet.</li>
                    </ul>

                    <h2>4. Propriedade Intelectual</h2>
                    <p>
                        Todos os materiais didáticos, vídeos e recursos fornecidos são protegidos por direitos autorais.
                        É proibida qualquer reprodução, distribuição ou compartilhamento, exceto para uso individual e exclusivo de aprendizado.
                    </p>

                    <h2>5. Pagamento e Cancelamento</h2>
                    <p>
                        Os valores, prazos e formas de pagamento serão definidos em contrato específico no momento da contratação.
                        Cancelamentos podem ser solicitados conforme a política de rescisão e reembolso descrita em contrato.
                    </p>

                    <h2>6. Proteção de Dados (LGPD)</h2>
                    <p>
                        Os dados pessoais serão tratados conforme a Lei nº 13.709/2018 (LGPD).
                        O uso dos dados será exclusivo para fins acadêmicos, administrativos e de comunicação com o usuário.
                        O usuário poderá solicitar acesso, correção ou exclusão dos dados pessoais através dos canais oficiais da Itera360.
                    </p>

                    <h2>7. Responsabilidades e Garantias</h2>
                    <p>
                        A Itera360 se compromete a prestar os serviços com qualidade e boas práticas pedagógicas.
                        Não há garantia de empregabilidade ao término do curso. O sucesso profissional depende da aplicação dos conhecimentos pelo próprio usuário.
                    </p>

                    <h2>8. Disposições Finais</h2>
                    <p>
                        Os termos podem ser alterados a qualquer momento, com aviso na plataforma.
                        O uso contínuo após alterações implica concordância com os novos termos.
                        Em caso de conflitos, o foro será a comarca de Alfenas/MG, com renúncia a qualquer outro, por mais privilegiado que seja.
                    </p>
                    <div className={style.download}>
                        <a
                            href={DocTermo}
                            download="Termos_Itera360.pdf"
                            className={style.botao_download}
                        >
                            Baixar Termos em PDF <FaFileDownload />
                        </a>
                    </div>
                </div>
                <div className={style.botao_termos}>
                    <Button
                        onClick={() => window.location.href = '/redefinirInformacoes'}
                        className={style.botao_voltar}
                    >
                        Voltar
                    </Button>
                </div>
            </div>

            <div className={style.conteudo_direita}>
                <img
                    src={superiorDireito}
                    alt="superiorDireito"
                    className={style.superior_direito}
                />
                <img
                    src={inferiorDireito}
                    alt="inferiorDireito"
                    className={style.inferior_direito}
                />
            </div>
        </div>
    );
}
